"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _index = _interopRequireDefault(require("../animation/motion-parallax/index"));
var _highlightText = _interopRequireDefault(require("./highlight-text"));
var _motionMove = _interopRequireDefault(require("../animation/motion-move"));
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StickyContentBlock = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "StickyContentBlock",
  class: "pl-s1w74fr1"
});
const TextWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextWrapper",
  class: "pl-t12rm54w"
});
const HiddenText = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HiddenText",
  class: "pl-h8eofmo"
});

/**
 * StickySection Component.
 *
 * @param {Object} props React props
 * @param {string} props.text Text including inline image {img} tags and line breaks {br}
 * @param {Object} props.inlineImage1 The inline image object
 * @param {Object} props.inlineImage2 The inline image object
 * @param {Object} props.inlineImage3 The inline image object
 * @returns {React.ReactElement} StickySection Component
 * @public
 */
function StickySection({
  text,
  inlineImage1,
  inlineImage2,
  inlineImage3
}) {
  const containerRef = (0, _react.useRef)(null);
  const [containerHeight, setContainerHeight] = (0, _react.useState)(0);
  const cleanText = text?.replace(/{img}/g, '')?.replace(/{br}/g, '');
  (0, _react.useEffect)(() => {
    const element = containerRef.current;
    if (!element) return;
    const observer = new ResizeObserver(([entry]) => {
      if (entry.contentRect?.height) {
        setContainerHeight(entry.contentRect.height);
      }
    });
    observer.observe(element);
    return () => {
      observer.unobserve(element);
      observer.disconnect();
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(StickyContentBlock, {
    dataCy: "sticky-section",
    dataPartial: "dark1",
    mode: "swift",
    intensity: "300",
    variant: "scaleUp",
    delay: 0.25,
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    id: "highlight-text",
    settings: {
      speed: 0.9
    }
  }, ({
    transformY
  }) => {
    const scrollProgress = containerHeight ? Math.min(transformY / containerHeight, 1) : 0;
    return /*#__PURE__*/_react.default.createElement(TextWrapper, null, /*#__PURE__*/_react.default.createElement(_highlightText.default, {
      textString: text,
      scrollProgress: scrollProgress,
      inlineImage1: inlineImage1,
      inlineImage2: inlineImage2,
      inlineImage3: inlineImage3
    }), /*#__PURE__*/_react.default.createElement(HiddenText, null, /*#__PURE__*/_react.default.createElement(_text.default.h2, {
      as: "paragraph",
      text: cleanText
    })));
  }));
}
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(StickySection);
StickySection.propTypes = {
  text: _propTypes.default.string,
  inlineImage1: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  inlineImage2: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  inlineImage3: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  })
};